// import {initScrollanim} from "./scrollanim.js";

// initScrollanim();

var isDebug = true;
isDebug = false;
if (isDebug) var debug = console.log.bind(window.console);
else var debug = function () {};

var thestate = {
  lastscroll: false,
  headersize: 0,
  myheaderfull: 0,
  startpage: false,
  mmenuopen: false,
  handheld: false,
};

window.thestate = thestate

function scrollCheck() {
  if (window.pageYOffset >= thestate.headersize) {
    $("#header").addClass("sticky");
    if (document.querySelector("body").classList.contains("frp")) {
      $("#header").css("top", -1 * thestate.headersize + "px");
    }
  } else {
    $("#header").removeClass("sticky");
    if (document.querySelector("body").classList.contains("frp")) {
      $("#header").css("top", "0px");
    }
  }

  if($(window).scrollTop() + $(window).height() > $(document).height() - $(window).height()/2.0 ) {
    //console.log("near bottom!");
    $(".stageb").addClass('go-up');    
  } else {
    $(".stageb").removeClass('go-up');    
  }

}

function onscroll() {
  if (thestate.lastscroll) return;
  scrollCheck();
  thestate.lastscroll = true;
  setTimeout(unthrottle, 100);
}

function onclick(el, fn) {
  document.querySelector(el).addEventListener("click", fn);
}

function onresize() {
  // resize_mainimg();
  init();  
  recalcRst();
  handleRst();
}

function unthrottle() {
  thestate.lastscroll = false;
  scrollCheck();
}

function init() {
  //console.log("hello update");
  onclick(".callbox", function () {
    let self = this;
    self.classList.add("active");
    setTimeout(function () {
      self.classList.remove("active");
    }, 2000);
  });

  if (window.innerWidth < 769) {
    thestate.handheld = true;
  }
  if (document.querySelector("body").classList.contains("frp")) {
    thestate.startpage = true;
  }

  // debug(document.querySelector('body').classList);
  if (thestate.startpage) {
    thestate.headersize = $("#header .myheader.full .wrapper").position().top;
    console.log("Startrpaage");
    if (thestate.handheld) {
      $("#main").css("position", "relative");
      $("#main").css("top", 1 * thestate.headersize + "px");
    }
  } else {
    thestate.headersize = Math.round(
      $("#header .myheader.full .wrapper").position().top
    );
    // thestate.headersize = document.querySelector('#header').getBoundingClientRect().height - document.querySelector('#header .myheader.full .wrapper').getBoundingClientRect().height;
    $("#header").css("top", -1 * thestate.headersize + "px");
    debug(thestate.headersize);
    debug("runnng init");
  }

  if (window.screen.width < 769) {
    thestate.handheld = true;
    // document.querySelector("body").classList.remove("frp");

    // make boxes clickable
    if (document.querySelector("#topmedia .ce_text")) {
      document
        .querySelector("#topmedia .ce_text")
        .addEventListener("click", function () {
          this.classList.add("hide");
        });
    }
    // make also inspiration boxes clickable
    if (document.querySelector("#inspiration.popbox.mod_article .ce_text")) {
      document
        .querySelector("#inspiration.popbox.mod_article .ce_text")
        .addEventListener("click", function () {
          this.classList.add("hide");
        });
    }

    // do startpage
    // let collection = document.querySelectorAll('.bg');

    // [].forEach.call(collection,function(el) {
    //     debug(el.parentElement)
    // })
  }

  // be sure to check j_accprdion.html5 in templates folder!

  // var slidersize = window.innerHeight - document.querySelector('#header').getBoundingClientRect().height;
  // if ($('.rsts-main')) {
  // $('.rsts-main').css('height',slidersize);
  // ''}
  // window.dispatchEvent(new Event('resize'));
}

function singleinit() {
  debug(thestate);
  debug(window.innerWidth);

  if (thestate.handheld && thestate.startpage) {
    debug("startpage on mobile / switching imgs");
    // handdle startpage
    let collection = document.querySelectorAll(".bg");
    [].forEach.call(collection, function (el) {
      let parent = el.parentElement;
      if (parent.id == "gamma") {
        el = parent.querySelector(".bgend");
        parent.style.backgroundImage = el.style.backgroundImage;
        debug(el.style);
      } else {
        parent.style.backgroundImage = el.style.backgroundImage;
        debug(el.style);
      }
    });
  }
}

function isinspirator() {
  if ("isinspirator" in thestate) {
    return thestate.isinspirator;
  }
  thestate.isinspirator = !!document.querySelector('#inspirator');
  return thestate.isinspirator;
}

function recalcRst() {
  //return true;
  if (isinspirator()) {
    let collection = document.querySelectorAll("#inspirator img");
    [].forEach.call(collection, function (el) {      
      el.removeAttribute("resized")   
    });
    debug("restting rst");   
  }
}

function handleRst() {
  //return true;
  //debug("Handling rst");
  if (isinspirator()) {
    //debug("Found rst inspirator");
    let shouldresize = false
    let collection = document.querySelectorAll("#inspirator img");
    [].forEach.call(collection, function (el) {
      if (!!el.getAttribute("resized")) return
      debug(el);
      _height = el.getAttribute("height");
      _width = el.getAttribute("width");
      let theheight = window.innerHeight - (document.querySelector('#header .wrapper').getBoundingClientRect().height + document.querySelector('#footer').getBoundingClientRect().height);      
      let prop_win = theheight / window.innerWidth
      let prop_img = _height / _width;
      debug(prop_win)
      debug(prop_img)
      if (prop_win >= prop_img) {           
        el.style.height = "auto";
        el.style.width = "100%";
        el.setAttribute("resized","h");
        shouldresize = true;
      }
      else {        
        el.style.height = theheight +"px";
        el.style.width = "auto";
        el.setAttribute("resized","v");
        shouldresize = true;
      }
      
      
    });
    if (shouldresize) {
      debug ("redrawing rsts");
      let sliderElement = [].slice.call(document.getElementsByClassName('mod_rocksolid_slider'), -1 )[0];
      let $ = jQuery;
      let slider = $(sliderElement);
      $(sliderElement).data('rstSlider').resize();
      //$([].slice.call(document.getElementsByClassName('mod_rocksolid_slider'), -1 )[0]).data('rstSlider').resize();
      window.dispatchEvent(new Event('resize.rsts'));
    }
  }
  //debug("finish Handling rst");
}

function initlickbox() {
  let clickimages = document.querySelectorAll(".img--clickable");
  let clickimageslen = clickimages.length;
  let list = [];
  for (let i = 0; i < clickimageslen; i++) {
    var el = clickimages[i];
    debug(el);
    debug(i);
    // create wrapper container
    var wrapper = document.createElement("a");
    wrapper.setAttribute("href", el.getAttribute("src"));
    wrapper.setAttribute("data-lightbox", i);
    wrapper.setAttribute("title", el.getAttribute("alt"));
    // insert wrapper before el in the DOM tree
    el.parentNode.insertBefore(wrapper, el);
    // move el into wrapper
    wrapper.appendChild(el);
  }

  let search = document.querySelector(".searchbox");
  search.addEventListener("click", function () {
    $(".searchmod").toggleClass("active");
    $(".searchbox").toggleClass("active");
  });
}

function initcards() {
  let cards = $(".card");
  for (let i = 0; i < cards.length; i++) {
    cards[i].addEventListener("click", function () {
      let link = $(this).find("a").attr("href");
      window.location.href = window.location.origin + "/" + link;

      debug(link);
    });
  }
}

/// Mobile menu

function initmobilemenu() {
  debug("Reunning Initmobilemenu");
  var b = document.querySelector(".mobilemenubutton");
  var c = document.querySelector(".mobilemenu");
  b.addEventListener("click", function () {
    if (thestate.mmenuopen) {
      this.classList.remove("active");
      c.classList.remove("active");
      thestate.mmenuopen = false;
      debug("click");
    } else {
      this.classList.add("active");
      c.classList.add("active");
      thestate.mmenuopen = true;
      debug("click");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // console.log("hello2x");
  window.onresize = onresize;

  onresize();
  setInterval(handleRst, 2000);
  //handleRst();
  init();
  singleinit();
  initlickbox();

  debug("init cards");
  initcards();
  initmobilemenu();

  $(window).scroll(function () {
    onscroll();
  });

  if (document.getElementById("#topmedia")) {
  }


  $(".stageb").on("click", function () {
    // click to scroll (on slider mostly)
    if (thestate.startpage == true) {
      if ($(".stageb").hasClass('go-up')) {
        //alert("hasclass");
        window.scroll({
          top: 0, // could be negative value
          left: 0,
          behavior: "smooth",
        });
      }
      else {

      
      window.scrollBy({
        top: $(window.top).height() * 2, // could be negative value
        left: 0,
        behavior: "smooth",
      });
    }
    } else {
      window.scrollBy({
        top: $(window.top).height(), // could be negative value
        left: 0,
        behavior: "smooth",
      });
    }
  });

  let footerheight = document.querySelector("#footer").getBoundingClientRect()
    .height;

  document.querySelector("#wrapper").style.paddingBottom = footerheight + "px";
});
